import { useEffect, useState } from 'react';

/** True when the viewport is narrower than `px`. */
export function useBelowWidth(px: number): boolean {
  const [below, setBelow] = useState(false);

  useEffect(() => {
    const media = window.matchMedia(`(max-width: ${px - 1}px)`);
    const sync = () => setBelow(media.matches);
    sync();
    media.addEventListener('change', sync);
    return () => media.removeEventListener('change', sync);
  }, [px]);

  return below;
}
